// Info/board/PersonMetaInfo.js
import React from "react";

const PersonMetaInfo = ({ person }) => {
  if (!person) return null;

  return (
    <div style={{ textAlign: "center" }}>
      <h4 style={{ fontSize: "1.5rem" }}>{person.name}, {person.age}</h4>
      <p style={{ fontSize: "1.1rem", marginTop: "0.5rem" }}>{person.desc}</p>
    </div>
  );
};

export default PersonMetaInfo;
